module.exports = __webpack_public_path__ + "e13349c8c9733b2a1e5e320287e36066.svg";